import React, { useEffect, useState } from "react";

const VIDEOS = [
  {
    id: 1,
    title: "Installation - Le phonambule",
    intent: "Comme les plantes conservées dans les serres du Jardin Botanique, des sons émanant de différents endroits sur Terre sont conservés dans des “serres numériques”, à l’instar de la collection du projet Aporee (voir https://aporee.org/), répertoire d’échantillons sonores. Il s’agit d’une forme de domestication d’objets “vivants”, non pas classés dans une taxonomie biologique mais géolocalisés et représentant un moment auditif d’un lieu et en gardant trace.\nLe phonambule est un être imaginaire qui, littéralement, “marche sur les sons”. Il est incarné par un dispositif qui permet de voyager à travers les sons de notre planète (ceux de la collection Aporee), telle une déambulation aléatoire et virtuelle.",
    device: "Captation de l’application phonambule sur une promenade fixée à 16 lieux visités par l’artiste\nSpatialisation en quadriphonie\nEcran placé horizontalement",
    broadcast: "Les serres du Jardin Botanique 17 avril 2026",
    thumb: "/assets/thumb3.jpg",
    src: "phonambule-domestication.mp4",
    relatedLink: "https://genin.ovh/phonambule/",
    thumb: "/assets/thumb3.jpg",
    year: 2026,
    duration: "04:01",
  },
  {
    id: 2,
    title: "Performance - COMEDIA",
    intent: "Présent dans l’espace scénique mais invisible pour le public, un.e auteur.ice écrit un texte en temps réel pendant quelques minutes, sous des contraintes choisies par le public. Dans le même temps, une intelligence artificielle produit un texte soumis aux règles identiques. Les deux processus d’écriture sont retransmis en direct sur grand écran, rendant visible la matérialité de l’acte d’écrire : frappes, hésitations, corrections, accélérations, décisions prises sous pression.\nAppel à projets Arts numériques 2025 / Ville de Liège",
    device: "Application accessible par le public via QR code\nProjection sur écran de 3x2.3m\nPC/Table de mixage pour le producteur\nPC pour l’auteur.ice\nImprimante",
    broadcast: "Performances aux Brasseurs les 10 et 18 avril 2026",
    thumb: "/assets/thumb3.jpg",
    src: "comedia-captation.mp4",
    relatedLink: "http://www.lesbrasseurs.org/2026/03/vendredi-10-samedi-18-avril-2026-20h.html",
    resources:"https://genin.ovh/COMEDIA_traces-avril2026.zip",
    year: 2026,
    duration: "02:54",
  },
  {
    id: 3,
    title: "Installation - Sortie de route",
    intent: "Le spectateur-résistant est invité à placer des formes sur la surface pour créer un paysage sonore unique, sa composition produisant une suite d’échantillons sonores modifiés et distordus par les positions et luminosité des formes.\nCette transposition d’un espace graphique 2D à un espace sonore imprévisible pemet au spectateur de déconstruire les liens entre un système contraint et la découverte de chemins différents, se libérant ainsi du cadre fixé.\n \nSortir de la route, résister.",
    device: "Webcam 4K\nApplication transformation image-MIDI (MAX/MSP)\nApplication quadruple sampler (MAX/MSP)\n16 samples variés : musique (Yttling Jazz, Kanding Ray, Agnes Obel, Demise of love), captations (crashes automobiles, Twin Peaks S01E01) politiciens (Musk, Meloni), philosophes (A.Barrault, JP. Foucault, Y.Harari).",
    broadcast: "Galerie des Beaux-Arts 6/7 mars 2026",
    thumb: "/assets/thumb3.jpg",
    src: "resiste-deanse.mp4",
    relatedLink: "https://beauxartsdeliege.be/la-galerie-des-beaux-arts-souvre-a-la-performance/",
    year: 2026,
    duration: "01:11",
  },
  {
    id: 4,
    title: "Installation - Techno-contrôle",
    intent: "Dénonciation de la croyance en la toute puissance de la technologie, de sa capacité à emporter l’humanité vers un futur radieux, solutionnant tous ses problèmes, dans une croissance sans fin.\nRéférence au manifeste du techno-optimisme, qui constitue l’une des sources à laquelle s’abreuvent les libertariens et autres néo-fascistes.\nLa danse en contrepoint, comme pratique ancestrale, sans contraintes et sans objectifs, pour nous sortir de l’emprise de ce contrôle sociétal.",
    device: "4 racks de leds (disposés en carré) audio-réactifs\nCaméra Fuji XH-2S\nCercle translucide (papier calque)\nSynthétiseur analogique MS-20",
    broadcast: "Galerie des Beaux-Arts 22/23 janvier 2026",
    thumb: "/assets/thumb3.jpg",
    src: "techno-controle-jury.mp4",
    relatedLink: "https://beauxartsdeliege.be/les-etudiants-de-video-expose-a-la-galerie-des-beaux-arts/",
    year: 2026,
    duration: "07:04",
  },
  {
    id: 5,
    title: "Restitution workshop — Lynch en scène(s)",
    intent: "Revisiter la scène de la Red Room (voir https://twinpeaks.fandom.com/wiki/Red_room) de la série Twin Peaks réalisée par David Lynch",
    device: "Ecran de diffusion",
    broadcast: "Salle pyramidale / Botanique / BAL",
    thumb: "/assets/thumb2.jpg",
    src: "rx-lynch.mp4",
    year: 2025,
    duration: "02:07",
  },
  {
    id: 6,
    title: "Séquence — indusPrana",
    intent: "Elle est animée par un souffle.\nElle respire constamment.\nOu plutôt expire de la fumée, sortant de cheminées, de tuyères, d’artères, du sol même.",
    device: "Caméra Canon XA10 sur pied, plans fixes uniquement.\nPlans larges et gros plans.\nQuatre moments de tournage (jours différents) pour une seule journée présentée.",
    broadcast: "Jury Beaux-Arts de Liège",
    thumb: "/assets/thumb2.jpg",
    src: "rx-indusPrana.mp4",
    year: 2025,
    duration: "05:31",
  },
   {
    id: 7,
    title: "Séquence — cycle n°1",
    intent: "D’abord l’envie de se rapprocher du sol.\nPuis de percevoir différemment la manière dont on se déplace.\nDe matérialiser visuellement notre propension à penser au prochain cycle avant d’en avoir terminé avec celui en cours.\nDe montrer qu’une mise en mouvement ne mène pas toujours bien loin.\nPour ne pas oublier l’importance du point fixe au centre, du moment présent.",
    device: "Caméra InstaX360 fixée à la roue avant d’une voiture.\nPrises de vue en grand angle/steady cam à 120 fps (résolution full HD).\nSynchronisation de la vitesse de la séquence avec le tempo d’Ableton Live.\nCaptation par OBS Studio de la sortie vidéo d’Ableton Live.\nTournage sur le pont Père Pire et environs.",
    broadcast: "Jury Beaux-Arts de Liège",
    thumb: "/assets/thumb1.jpg",
    src: "reduxCycle1.mp4",
    year: 2025,
    duration: "02:39",
  },
  {
    id: 8,
    title: "Installation — OOO-X-PO",
    intent: "Volonté de signifier les constants parasitages sonores et visuels de l’espace public par la publicité.\nVolonté de tourner en dérision les messages publicitaires, tant au niveau visuel que sonore, en les revisitant.",
    device: "Création d’une cinquantaine de logos revisités (mélange des formes initiales, mélange des couleurs, …)\nCréation d’un patch dans Max/MSP (Cycling74) qui mélange aléatoirement un logo avec un slogan, à une fréquence variable\n",
    broadcast: "Galerie des Beaux-Arts à Liège en décembre 2024",
    thumb: "/assets/thumb2.jpg",
    src: "OOO-x-po.mp4",
    year: 2024,
    duration: "01:55",
  },
  
  {
    id: 9,
    title: "Séquence — Bad trip",    
    intent: "Respirer malgré la pollution autoroutière, qui s'insinue jusqu'au coeur de nos villes.",
    device: "Une dizaine de séquences vidéo.\nPatch MAX/MSP (Cycling74) audio-réactif.",
    broadcast: "Jury Beaux-Arts de Liège",
    thumb: "/assets/thumb3.jpg",
    src: "rx-badTrip.mp4",
    year: 2023,
    duration: "01:33",
  },
 
  {
    id: 10,
    title: "Séquence — Mumbius",
    intent: "Transformation des parcours en tuk-tuk sur les routes indiennes en un paysage abstrait",
    device: "Séquences vidéo captées en direct.\nPatch MAX/MSP (Cycling74) audio-réactif",
    broadcast: "Jury Beaux-Arts de Liège",
    thumb: "/assets/thumb3.jpg",
    src: "rx-mumbius.mp4",
    year: 2024,
    duration: "02:42",
  },
  {
    id: 11,
    title: "Séquence — Cyberpunk",
    intent: "Mélange d'images issues du jeu Cyberpunk 2077",
    device: "Patch MAX/MSP (Cycling74) audio-réactif",
    broadcast: "Jury Beaux-Arts de Liège",
    thumb: "/assets/thumb2.jpg",
    src: "Cyberpunk.mp4",
    year: 2023,
    duration: "03:31",
  },
   {
    id: 12,
    title: "Séquence — Danse n°1",
    intent: "La danse comme exutoire, comme défouloir",
    device: "Patch MAX/MSP (Cycling74) audio-réactif",
    broadcast: "Jury Beaux-Arts de Liège",
    thumb: "/assets/thumb3.jpg",
    src: "rx-danseN°1.mp4",
    year: 2022,
    duration: "02:19",
  },
   
  
];

const testLink = s => s == null ? "" : <p><strong>Lien :</strong><br /><a href={s}>{s}</a></p> 
const testResources = s => s == null ? "" : <p><strong>Ressources :</strong><br /><a href={s}>{s}</a></p> 


export default function App() {
  const [active, setActive] = useState(null);

  // Fermer la modale sur ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setActive(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="site">
      {/* Header */}
      <header className="header">
        <div className="container header__inner">
          <div className="brand">
            <div>
              <h1 className="brand__title">bernard genin</h1>
              <p className="brand__subtitle">Artiste vidéo — installations & performances</p>
            </div>
          </div>
          <nav className="nav">
            <a href="#works">Œuvres</a>
            <a href="#about">À propos</a>
            <a href="#contact">Contact</a>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="hero" aria-label="Présentation">
        <video
          className="hero__video"
          src={VIDEOS[6].src}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="hero__overlay" />
        <div className="container hero__content">
        </div>
      </section>

      {/* Works */}
      <main className="container main">
        <section id="works" className="section">
          <h3 className="section__title">Œuvres</h3>
            <div className="grid">
              {VIDEOS.map((v) => (
                <article key={v.id} className="card">
                  <button
                    className="card__thumb"
                    onClick={() => setActive(v)}
                  >
                    <img src={v.thumb} alt={v.title} />
                    <span className="card__play">▶</span>
                  </button>

                  <div className="card__body">
                    <h4 className="card__title">{v.title}</h4>
                    <p className="card__meta">
                      {v.year} • {v.duration}
                    </p>
                    <div className="oeuvre__fiche">
                      <p>
                        <strong>Intention :</strong><br />
                        {v.intent}
                      </p>

                      <p>
                        <strong>Dispositif :</strong><br />
                        {v.device}
                      </p>

                      <p>
                        <strong>Diffusion :</strong><br />
                        {v.broadcast}
                      </p>
                      {testLink(v.relatedLink)}
                      {testResources(v.resources)}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>

        {/* Modal player */}
        {active && (
          <div className="modal" role="dialog" aria-modal="true" aria-label={active.title}>
            <div className="modal__panel">
              <div className="modal__bar">
                <h5 className="modal__title">{active.title}</h5>
                <div className="modal__actions">
                  <a className="link" href={active.src} target="_blank" rel="noreferrer">Ouvrir la source</a>
                  <button className="link" onClick={() => setActive(null)}>Fermer ✕</button>
                </div>
              </div>
              <video src={active.src} controls autoPlay className="modal__video" />
              <div className="modal__notes">
                
              </div>
            </div>
          </div>
        )}

        {/* About */}
        <section id="about" className="section layout">
          <div className="layout__main">
            <h3 className="section__title">À propos</h3>
            <p>
              Bernard Genin développe son travail au croisement de la performance, de l’installation et du cinéma expérimental.
              </p>  <p>Artiste multidisciplinaire, il associe son expérience des arts de la scène et des arts numériques 
              pour créer des œuvres qui expriment un engagement critique face au consumérisme et au techno-optimisme. </p>
               <p> Utilisant projections, captation en temps réel des sons et traitement visuel, 
              il explore des formes hybrides, où le théâtre, la musique et l’image dialoguent, se confrontent et se transforment mutuellement. </p>
             
            
            
          </div>
          
        </section>

      {/* Contact */}
        <section id="contact" className="section box">
          <h3 className="section__title">Contact</h3>
         
          <div className="cols cols--split">
            <form className="form" onSubmit={(e) => e.preventDefault()}>
              <input className="input" placeholder="Votre nom" />
              <input className="input" placeholder="Email" />
              <input className="input" placeholder="Sujet" />
              <textarea className="input input--area" placeholder="Message" />
              <button className="btn">Envoyer</button>
            </form>
            
          </div>
        </section>

        <footer className="footer">© {new Date().getFullYear()} bernard genin — Tous droits réservés</footer>
      </main>
    </div>
  );
}
